import { useToast as useNuxtToast } from '@nuxt/ui/composables/useToast'
import { addKontyToast } from 'app-theme'
import type { UiColor } from '@/types/components'

export interface IToastOptions {
  /** ms; without it the shared rules pick 2.5 s for a confirmation, 6 s for a warning or error */
  duration?: number
}

/**
 * The POS's one way to show a toast. It applies the shared Konty toast rules
 * (`addKontyToast`): one toast at a time, the text centred, an icon on a success, warning or error.
 */
export function useToast() {
  const nuxtToast = useNuxtToast()

  function toast(message: string, color: UiColor = 'neutral', options: IToastOptions = {}): void {
    addKontyToast(nuxtToast, { description: message, color, duration: options.duration })
  }

  return { toast }
}
